import React from 'react';
import { ToastContainer } from 'react-toastify'
import Spinner from '../Spinner/spinner';
import Pagination from '../Pagination/pagination';
import { NavLink } from 'react-router-dom';
import UseState from './Hooks/useState';

const State = () => {
    const {
        stateData,
        page,
        count,
        PER_PAGE,
        spinner,
        filter,
        stateLists,
        setStateId,
        setPage,
        deleteState,
        handleChange,
    } = UseState()
    return (
        <>
            <ToastContainer />
            <section>
                <div className="m-t-3 cus-padd cusheight">
                    {spinner ? <Spinner /> : null}
                    <header>
                        <h2 className='page-tittle'>
                            State
                        </h2>
                        <hr />
                    </header>
                    <p>Total State : {stateData.totalCount}</p>
                    <div className='d-flex justify-content-end align-item-center'>
                        <div className='me-1'>
                            <input type="text" className='form-control' placeholder='Search by country' name='country' value={filter.country} onChange={(e) => handleChange(e)} />
                        </div>
                        <div>
                            <input type="text" className='form-control' placeholder='Search by state' name='state' value={filter.state} onChange={(e) => handleChange(e)} />
                        </div>
                        <div>
                            <button className='btn btn-primary ms-1' value={filter.state} onClick={() => stateLists()}>Search</button>
                            <button className='btn btn-dark ms-1' onClick={() => window.location.reload()}>Reset</button>
                            <NavLink to='addState'><button className='btn btn-dark ms-1 float-end mb-2'>Add State</button></NavLink>
                        </div>
                    </div>
                    <table className="table  shadow mt-3">
                        <thead className="table-dark">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Code</th>
                                <th scope="col">Country</th>
                                <th scope="col">State</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                stateData?.data?.length === undefined ? <div className='position-absolute top-10 end-50 mt-5'><h3>No record found</h3></div>
                                    :
                                    <>
                                        {
                                            stateData.data?.map((item, index) =>
                                                <tr key={index}>
                                                    <th scope="row" >{PER_PAGE * (page - 1) + index + 1}</th>
                                                    <td>{item.code}</td>
                                                    <td>{item.countryName}</td>
                                                    <td>{item.name}</td>
                                                    <td>
                                                        <NavLink to={`editState/${item._id}`}><svg style={{ cursor: "pointer", fill: 'black' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-pencil-fill" viewBox="0 0 16 16">
                                                            <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                                        </svg>
                                                        </NavLink>
                                                        <svg onClick={() => setStateId(item._id)} data-bs-toggle="modal" data-bs-target="#unavailabilitydelete" style={{ cursor: "pointer", marginLeft: '15px', fill: 'red' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#e62222" className="bi bi-trash-fill" viewBox="0 0 16 16">
                                                            <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                                        </svg>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </>
                            }
                        </tbody>
                    </table>
                    <div className='w-100 d-flex justify-content-center'>
                        {count > 10 &&
                            <Pagination setpage={setPage} count={Math.ceil(count / PER_PAGE)} page={page} />
                        }
                    </div>

                    {/* Delete State Start */}
                    <div className="modal fade" id="unavailabilitydelete" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-sm">
                            <div className="modal-content">
                                <div className="modal-body text-center">
                                    <p>Are You Sure !</p>
                                    <p>You want to delete state
                                    </p>
                                    <button type="button" className="btn nobtn" data-bs-dismiss="modal">No</button>
                                    <button type="button" onClick={() => deleteState()} className="btn yesbtn" data-bs-dismiss="modal">Yes</button>
                                </div>

                            </div>
                        </div>
                    </div>
                    {/* Delete State End */}

                </div>
            </section>
        </>
    )
}

export default State;